import React from "react";
import { useParams } from "react-router-dom";
import SelfReadingDetailSection from "../sections/SelfReadingDetailSection";
import { ContractType } from "features/contracts/enums/contractType";

export interface Props {
  id?: string;
  readingId?: string;
  contractType: ContractType;
}

const SelfReadingDetail = (props: Props) => {
  // router
  const { readingId } = useParams<Props>();

  // render
  return (
    <SelfReadingDetailSection
      selfReadingId={readingId!}
      contractType={props.contractType}
    />
  );
};

export default SelfReadingDetail;
